import { baseApi } from "../baseApi";
import { pick } from "../util";
import type { ApiUsageOrgRow, ApiUsageUserRow } from "../types";

export const apiUsageApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Platform owner only — call totals grouped by organization.
    getApiUsageByOrganization: builder.query<
      ApiUsageOrgRow[],
      { startDay: string; endDay: string }
    >({
      query: ({ startDay, endDay }) => ({
        body: {
          query: `
            query ApiUsageByOrganization($startDay: String!, $endDay: String!) {
              apiUsageByOrganization(startDay: $startDay, endDay: $endDay) {
                organizationId
                totalCalls
                totalErrors
                userCount
                lastAt
              }
            }
          `,
          variables: { startDay, endDay },
        },
      }),

      transformResponse: (res: unknown) =>
        pick<ApiUsageOrgRow[]>(res, "apiUsageByOrganization"),

      providesTags: [{ type: "ApiUsage", id: "ORG" }],
    }),

    // Platform owner only — per-user, per-operation breakdown for one org.
    getApiUsageByUser: builder.query<
      ApiUsageUserRow[],
      { organizationId: string; startDay: string; endDay: string }
    >({
      query: ({ organizationId, startDay, endDay }) => ({
        body: {
          query: `
            query ApiUsageByUser(
              $organizationId: String!
              $startDay: String!
              $endDay: String!
            ) {
              apiUsageByUser(
                organizationId: $organizationId
                startDay: $startDay
                endDay: $endDay
              ) {
                userId
                operation
                totalCalls
                totalErrors
                lastAt
              }
            }
          `,
          variables: { organizationId, startDay, endDay },
        },
      }),

      transformResponse: (res: unknown) =>
        pick<ApiUsageUserRow[]>(res, "apiUsageByUser"),

      providesTags: [{ type: "ApiUsage", id: "USER" }],
    }),
  }),
});

export const {
  useGetApiUsageByOrganizationQuery,
  useGetApiUsageByUserQuery,
} = apiUsageApi;
